export var NoteNode;
(function (NoteNode) {
    NoteNode["Note"] = "yfm_note";
    NoteNode["NoteTitle"] = "yfm_note_title";
    NoteNode["NoteContent"] = "yfm_note_content";
})(NoteNode || (NoteNode = {}));
export var NoteAttrs;
(function (NoteAttrs) {
    NoteAttrs["Class"] = "class";
    NoteAttrs["Type"] = "note-type";
})(NoteAttrs || (NoteAttrs = {}));
